var React = require('react');

function ManAstronaut (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M17.2,7.5V6A5.25,5.25,0,0,0,6.7,6V7.5","key":1}),React.createElement("path",{"className":"a","d":"M2.2,23.25a9.75,9.75,0,0,1,19.5,0","key":2}),React.createElement("path",{"className":"a","d":"M17.2,7.5c0,2.071-2.351,4.372-5.25,4.372S6.7,9.571,6.7,7.5s2.35-3.75,5.25-3.75S17.2,5.429,17.2,7.5Z","key":3}),React.createElement("path",{"className":"a","d":"M15.323,18.622A1.875,1.875,0,1,0,17.2,20.5a1.875,1.875,0,0,0-1.875-1.875Z","key":4}),React.createElement("line",{"className":"a","x1":"7.448","y1":"18.622","x2":"10.448","y2":"18.622","key":5}),React.createElement("line",{"className":"a","x1":"7.448","y1":"21.622","x2":"10.448","y2":"21.622","key":6}),React.createElement("path",{"className":"a","d":"M6.8,8.25H6.7a3,3,0,0,0-3,3v6.8","key":7}),React.createElement("path",{"className":"a","d":"M20.2,18.051v-6.8a3,3,0,0,0-3-3h-.105","key":8})]);
}

ManAstronaut.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ManAstronaut;

ManAstronaut.default = ManAstronaut;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/man-astronaut.svg
// module id = 1074
// module chunks = 0